import { useState, type ReactElement } from 'react'
import classnames from 'classnames'

import Header from '@/components/common//Header'
import css from './styles.module.css'
import SafeLoadingError from '../SafeLoadingError'
import SideDrawer from './SideDrawer'
import PsaBanner from '../PsaBanner'

const PageLayout = ({ children }: { children: ReactElement }): ReactElement => {
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(true)

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev)
  }

  return (
    <>
      <header className={css.header}>
        <PsaBanner />
        <Header onMenuToggle={toggleSidebar} />
      </header>

      <SideDrawer isOpen={isSidebarOpen} onToggle={setSidebarOpen} />

      <div className={classnames(css.main, !isSidebarOpen && css.mainNoSidebar)}>
        <div className={css.content}>
          <SafeLoadingError>{children}</SafeLoadingError>
        </div>
      </div>
    </>
  )
}

export default PageLayout
